const GalleryPage = (($) => {
  let _els = {};
  // let _windowWidth = window.innerWidth;

  // const _break = 768;

  const init = () => {
    _els.galleryContainer = $('.grid');
    _els.allItems = $('.grid > .grid-item');
    // _els.filtersAllBtn = $('#filters .btn');
    // _els.filterRadios = $('#filters input[type="radio"]');

    _els.galleryContainer.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'packery',
    });

    // All button
    // _els.filtersAllBtn.on('click', (e) => {
    //   _els.galleryContainer.isotope({ filter: '*' });
    //   _els.filterRadios.prop('checked', false);
    //   _resetGallery();
    // });

    // Location radios
    // _els.filterRadios.on('change', (e) => {
    //   let $this = $(e.target);
    //   let filterVal = $this.attr('data-filter');
    //   _els.galleryContainer.isotope({ filter: filterVal });
    //   _resetGallery();
    // });

    // gallery
    _initGallery();
  };

  const _initGallery = () => {
    _els.galleryContainer.lightGallery({
      download: false,
      getCaptionFromTitleOrAlt: false,
      selector: '.grid-item',
    });
  };

  // const _resetGallery = () => {
  //   // get currently filtered items from isotope and add / remove class
  //   var $filteredItems = $(_els.galleryContainer.isotope('getFilteredItemElements'));
  //   _els.allItems.removeClass('iso-visible');
  //   $filteredItems.addClass('iso-visible');

  //   // destroy the existing gallery and re-initialize
  //   _els.galleryContainer.data('lightGallery').destroy(true);
  //   _els.galleryContainer.lightGallery({
  //     download: false,
  //     getCaptionFromTitleOrAlt: false,
  //     selector: '.grid-item.iso-visible',
  //   });
  // };

  module.exports = {
    init: init,
  };
})(jQuery);
